import TextCreate from 'core/display/simple/Text'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class BetText extends TextCreate{
  constructor(data) {
    super(data)

    if(data.hide) {
      this.visible = false
    }

    signal.on('FREEBET:END', () => {
      this.update(FormatService.currency(game.models.BetModel.getValue()))
    })

    signal.on('MODEL:BET', (value) => {
      this.update(FormatService.currency(value))
    })
  }
}
